import React from 'react';
import { Box } from '@mui/material';
import EstimatesList from '../components/estimates/EstimatesList';
import type { Estimate, EstimateSettings } from '../types/estimateDetail';

export type { Estimate, EstimateSettings };

const EstimatesPage: React.FC = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <EstimatesList />
    </Box>
  );
};

export default EstimatesPage;
